import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { EnergyDrinkFlavorType } from 'src/app/products/interfaces/models';

import { EnergyDrinkProperties } from '@app/api/marketplace/models';
import { SubformBaseWithSugarContentPropertiesComponent } from '@products/components/forms/subform-base-with-sugar-content-properties/subform-base-with-sugar-content-properties.component';
import { sugarContentValidators } from '@shared/validators/sugar-content.validators';

@Component({
  selector: 'app-energy-drink-properties-subform',
  styleUrls: ['./energy-drink-properties-subform.component.scss'],
  templateUrl: './energy-drink-properties-subform.component.html',
})
export class EnergyDrinkPropertiesSubformComponent extends SubformBaseWithSugarContentPropertiesComponent {
  override alcoholic = false;
  DICT_PATH = 'PRODUCTS.ENERGY_DRINK_PROPERTIES';

  flavorType = EnergyDrinkFlavorType;

  static buildForm(fb: FormBuilder, data?: EnergyDrinkProperties) {
    return fb.group({
      flavorTypes: [data?.flavorTypes, Validators.required],
      basedOnSoy: [data?.basedOnSoy ?? false],
      containsMetilXantin: [data?.containsMetilXantin ?? false],
      containsTaurinOrGingsengOrLarginin: [
        data?.containsTaurinOrGingsengOrLarginin ?? false,
      ],
      ...(data?.containsMetilXantin && {
        metilXantinAmount: [data?.metilXantinAmount, sugarContentValidators],
      }),
      ...(data?.basedOnSoy && {
        proteinContentIsOver28PercentByWeight: [
          data?.proteinContentIsOver28PercentByWeight,
        ],
      }),
      containsFruitsOrVegetablesAtLeast50Percent: [
        data?.containsFruitsOrVegetablesAtLeast50Percent ?? false,
      ],

      ...{
        // build sugar content properties
        ...SubformBaseWithSugarContentPropertiesComponent.buildFields(data, {
          skipSugarContentInGramsPerHundredMilliliters: true,
        }),
      },
    });
  }

  onContainsMetilXantinChanged(contains: boolean) {
    if (contains) {
      this.group.addControl(
        'metilXantinAmount',
        this.fb.control(null, sugarContentValidators)
      );
    } else {
      this.group.removeControl('metilXantinAmount');
    }
  }

  onBasedOnSoyChanged(contains: boolean) {
    if (contains) {
      this.group.addControl(
        'proteinContentIsOver28PercentByWeight',
        this.fb.control(false)
      );
    } else {
      this.group.removeControl('proteinContentIsOver28PercentByWeight');
    }
  }
}
